import { Controller } from "@hotwired/stimulus"

// Sur le formulaire compte : à la saisie d'un SIRET (14 chiffres)
//  1. anti-doublon : prévient si le SIRET existe déjà (+ lien vers la fiche)
//  2. autofill : remplit raison sociale (nom légal), nom commercial SI VIDE, adresse,
//     ville, CP depuis data.gouv (champs VIDES only). À la création (name vide) le nom
//     commercial = la raison sociale par défaut ; sur une fiche existante son nom
//     commercial déjà saisi n'est PAS écrasé. Affiche le nom officiel résolu.
export default class extends Controller {
  static targets = ["warning", "resolved", "name", "raisonSociale", "address", "city", "postalCode", "sector", "companySize"]
  static values  = { url: String, lookupUrl: String, excludeId: String }

  check(event) {
    const siret = event.target.value.replace(/\s/g, "")
    if (siret.length !== 14) { this.#hide(this.hasWarningTarget && this.warningTarget); this.#clearResolved(); return }
    this.#dupCheck(siret)
    this.#autofill(siret)
  }

  async #dupCheck(siret) {
    if (!this.hasUrlValue || !this.hasWarningTarget) return
    const u = new URL(this.urlValue, window.location.origin)
    u.searchParams.set("siret", siret)
    if (this.excludeIdValue) u.searchParams.set("exclude_id", this.excludeIdValue)
    try {
      const { count, existing } = await (await fetch(u)).json()
      if (count > 0) {
        this.warningTarget.innerHTML = existing
          ? `Ce SIRET est déjà associé à « ${this.#esc(existing.name)} » — <a href="${existing.url}" class="underline font-semibold">ouvrir la fiche</a>.`
          : `Ce SIRET est déjà associé à ${count} compte${count > 1 ? "s" : ""}.`
        this.warningTarget.classList.remove("hidden")
      } else {
        this.#hide(this.warningTarget)
      }
    } catch (_) { /* silencieux */ }
  }

  async #autofill(siret) {
    if (!this.hasLookupUrlValue) return
    const u = new URL(this.lookupUrlValue, window.location.origin)
    u.searchParams.set("siret", siret)
    try {
      const d = await (await fetch(u)).json()
      if (!d.found) { this.#setResolved("SIRET introuvable sur data.gouv.", false); return }
      this.#setResolved(`✓ ${d.raison_sociale}`, true)
      if (this.hasRaisonSocialeTarget) this.#fillIfEmpty(this.raisonSocialeTarget, d.raison_sociale)
      if (this.hasNameTarget) this.#fillIfEmpty(this.nameTarget, d.raison_sociale)
      if (this.hasAddressTarget) this.#fillIfEmpty(this.addressTarget, d.adresse)
      if (this.hasCityTarget) this.#fillIfEmpty(this.cityTarget, d.ville)
      if (this.hasPostalCodeTarget) this.#fillIfEmpty(this.postalCodeTarget, d.code_postal)
      if (this.hasSectorTarget) this.#fillIfEmpty(this.sectorTarget, d.sector)
      if (this.hasCompanySizeTarget) this.#fillIfEmpty(this.companySizeTarget, d.company_size)
    } catch (_) { /* silencieux */ }
  }

  #fillIfEmpty(el, val) { if (el && !el.value && val) el.value = val }

  #setResolved(text, ok) {
    if (!this.hasResolvedTarget) return
    this.resolvedTarget.textContent = text
    this.resolvedTarget.classList.remove("hidden")
    this.resolvedTarget.classList.toggle("text-success", ok)
    this.resolvedTarget.classList.toggle("text-text-muted", !ok)
  }

  #clearResolved() { if (this.hasResolvedTarget) this.resolvedTarget.classList.add("hidden") }
  #hide(el) { if (el) el.classList.add("hidden") }
  #esc(s) { const d = document.createElement("div"); d.textContent = s ?? ""; return d.innerHTML }
}
